import {Tripbook} from "../../entities/Tripbook.ts";
import {TripbookRepository} from "../../../repositories/TripbookRepository.ts";

export class CreateTripbookUseCase{
    constructor(private tripbooksRepository: TripbookRepository){}
    async execute(tripBook:Tripbook): Promise<Tripbook>{
        return this.tripbooksRepository.createTripbook(tripBook);
    }
}
